// validation.js
function limpiarRUT(rut) {
    return typeof rut === 'string' ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase() : '';
  }
  
  function formatearRUT(rut) {
    var rutLimpio = limpiarRUT(rut);
    if (rutLimpio.length > 9) {
      rutLimpio = rutLimpio.substring(0, 9);
    }
    if (rutLimpio.length === 0) {
      return '';
    }
    if (rutLimpio.length > 1) {
      var cuerpo = rutLimpio.slice(0, -1);
      var dv = rutLimpio.slice(-1);
      return cuerpo + '-' + dv;
    }
    return rutLimpio;
  }
  
  function validarRUT(rut) {
    var valor = limpiarRUT(rut);
    if (valor.length < 8) return false;
  
    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();
    var suma = 0;
    var multiplo = 2;
  
    for (var i = 1; i <= cuerpo.length; i++) {
      var index = parseInt(cuerpo.charAt(cuerpo.length - i), 10) * multiplo;
      suma += index;
      multiplo = (multiplo < 7) ? multiplo + 1 : 2;
    }
  
    var dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? 0 : dvEsperado;
    dvEsperado = dvEsperado === 10 ? "K" : dvEsperado;
  
    return dvEsperado.toString().toUpperCase() === dv;
  }
  
  function validarCorreo(email) {
    const esCorreoValido = validator.isEmail(email);
    const terminaConCaracterEspecial = /[!#$%&'*+/=?^_`{|}~.-]$/.test(email);
    return esCorreoValido && !terminaConCaracterEspecial;
  }
  
  function validarTelefono(numero) {
    const regex = /^9[0-9]{8}$/;
    return regex.test(numero);
  }
  